/**
 * Cut-down version of the Metropolis implementation.
 *
 * {@link https://github.com/SEEK-Jobs/metropolis/blob/master/packages/anz-candidate-header-footer/src/legacy-style-guide/react/Logo/LogoText.tsx}
 */

import React from 'react';

export const LogoText = () => (
  <g fill="#1c1c1c">
    <path
      d="M86.641,45.601c-3.697,0-7.037-0.408-10.012-3.385l3.834-3.833c1.942,1.938,4.467,2.208,6.269,2.208
      c2.031,0,4.148-0.675,4.148-2.434c0-1.174-0.629-1.985-2.479-2.167l-3.699-0.36c-4.24-0.404-6.854-2.253-6.854-6.586
      c0-4.869,4.282-7.485,9.064-7.485c3.653,0,6.72,0.632,8.976,2.75l-3.607,3.653c-1.354-1.217-3.43-1.576-5.459-1.576
      c-2.344,0-3.336,1.082-3.336,2.254c0,0.857,0.361,1.85,2.436,2.03l3.7,0.361c4.643,0.45,6.992,2.932,6.992,6.9
      C96.612,43.118,92.19,45.601,86.641,45.601z"
    />
    <path
      d="M104.548,35.405c0,3.022,1.85,5.232,5.143,5.232c2.568,0,3.832-0.722,5.32-2.21l3.564,3.472
      c-2.391,2.392-4.691,3.701-8.932,3.701c-5.547,0-10.867-2.526-10.867-12.045c0-7.668,4.148-11.997,10.236-11.997
      c6.539,0,10.238,4.783,10.238,11.232v2.614H104.548z M112.938,28.863c-0.635-1.396-1.943-2.434-3.926-2.434
      c-1.986,0-3.293,1.038-3.924,2.434c-0.361,0.859-0.494,1.491-0.541,2.529h8.932C113.433,30.354,113.298,29.723,112.938,28.863z"
    />
    <path
      d="M127.685,35.405c0,3.022,1.852,5.232,5.141,5.232c2.572,0,3.836-0.722,5.324-2.21l3.562,3.472
      c-2.391,2.392-4.691,3.701-8.93,3.701c-5.549,0-10.871-2.526-10.871-12.045c0-7.668,4.15-11.997,10.24-11.997
      c6.539,0,10.238,4.783,10.238,11.232v2.614H127.685z M136.075,28.863c-0.633-1.396-1.941-2.434-3.924-2.434
      c-1.986,0-3.295,1.038-3.926,2.434c-0.361,0.859-0.496,1.491-0.541,2.529h8.932C136.571,30.354,136.435,29.723,136.075,28.863z"
    />
    <path
      d="M160.339,45.331l-5.77-9.792l-2.486,2.802v6.99h-5.861V13.214h5.861v18.224l7.805-9.608h7.084l-8.391,9.473l9.02,14.029
      H160.339z"
    />
  </g>
);
